export default __webpack_public_path__ + "93f613197873c53116f61a052379b693.png";